import { render, staticRenderFns } from "./LoginPageContacts.vue?vue&type=template&id=667fa358&"
import script from "./LoginPageContacts.vue?vue&type=script&lang=js&"
export * from "./LoginPageContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports